// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const uk: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': 'Як грати',
  'howto.pieces.heading': 'Елементи',
  'howto.pieces.source': 'Джерело',
  'howto.pieces.mirror': 'Дзеркало',
  'howto.pieces.switch': 'Перемикач',
  'howto.pieces.exit': 'Вихід',
  'howto.pieces.wall': 'Стіна',
  'howto.controls.heading': 'Керування',
  'howto.controls.clickSlot.line1': 'Клацни по клітинці',
  'howto.controls.clickSlot.line2': 'постав дзеркало',
  'howto.controls.dragMirror.line1': 'Тягни дзеркало',
  'howto.controls.dragMirror.line2': 'оберни',
  'howto.controls.rightClick.line1': 'Правий клік',
  'howto.controls.rightClick.line2': 'прибери дзеркало',
  'howto.controls.hint':
    'Коліщатко миші: точне обертання на 1°.   Тап по дзеркалу: обертання на 15°.',
  'howto.objective.line1': 'Засвіти кожен перемикач — замок виходу відкривається.',
  'howto.objective.line2': 'Потім клацни по виходу. Розв’яжи з найменшою кількістю дзеркал.',

  'howtoColor.title': 'Колір і призми',
  'howtoColor.pieces.heading': 'Нові елементи',
  'howtoColor.pieces.prism': 'Призма',
  'howtoColor.pieces.redSwitch': 'Червоний перемикач',
  'howtoColor.pieces.yellowSwitch': 'Жовтий перемикач',
  'howtoColor.pieces.whiteSwitch': 'Білий перемикач',
  'howtoColor.how.heading': 'Як вони працюють',
  'howtoColor.how.line1': 'Білий промінь несе одночасно червоне, зелене й синє світло.',
  'howtoColor.how.line2': 'Призма розділяє біле світло на три кольорові промені по трьох гранях.',
  'howtoColor.how.line3': 'Клацни по встановленій призмі, щоб обернути її вхідну грань.',
  'howtoColor.switches.line1': 'Перемикачі мають кольорові точки — це колір, який вони просять.',
  'howtoColor.switches.line2':
    'Жовтому перемикачу (червона + зелена точки) потрібні обидва кольори одночасно.',
  'howtoColor.switches.line3':
    'Білому перемикачу (усі три) потрібні червоний, зелений І синій одночасно.',

  'options.hints.label': 'Показувати кути підказок у головоломках',
  'options.hints.help': 'Показує кут між падаючим і відбитим променем при кожному відбитті.',

  'level.01-intro.title': 'Привіт, світло',
  'level.02-two-mirrors.title': 'Два повороти',
  'level.03-corner.title': 'Стіна на шляху',
  'level.04-two-targets.title': 'Дві цілі',
  'level.05-tight.title': 'Тісно',
  'level.06-hello-color.title': 'Привіт, кольоре',
  'level.07-pick-a-side.title': 'Вибери бік',
  'level.08-yellow.title': 'Жовтий',
  'level.09-magenta.title': 'Маджента',
  'level.10-spectrum.title': 'Спектр',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': 'прямий',
  'puzzle.hint.angleType.acute': 'гострий',
  'puzzle.hint.angleType.obtuse': 'тупий',
  'puzzle.hint.label': '{angle}°\n{type}',
};
